"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PAGINATION_HEIGHT = exports.PAGER_SIZE = void 0;
var PAGER_SIZE = 5; // Set an odd number

exports.PAGER_SIZE = PAGER_SIZE;
var PAGINATION_HEIGHT = 30;
exports.PAGINATION_HEIGHT = PAGINATION_HEIGHT;